import Action from '../Action';
import VehicleStatsService from '../../services/VehicleStatsService.js';
import { message } from 'antd';

export function getVehicleStats() {
	return (dispatch) => {
		VehicleStatsService.getStats()
			.then((vehicledata) => {
				dispatch({ type: Action.GET_VEHICLESTATS, vehicleStats: vehicledata.data });
				message.success('Fetched Vehicle Stats');
			})
			.catch((error) => message.error('Failed to get Vehicle Stats!'));
	};
}
